import { render } from "./TheMetadataVariableLayout.vue?vue&type=template&id=a6dd9190&scoped=true"
import script from "./TheMetadataVariableLayout.vue?vue&type=script&lang=js"
export * from "./TheMetadataVariableLayout.vue?vue&type=script&lang=js"

import "./TheMetadataVariableLayout.vue?vue&type=style&index=0&id=a6dd9190&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6dd9190"]])

export default __exports__